<template>
  <div class="class-quiz-base-prompt">
    <slot />
  </div>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.class-quiz-base-prompt {
  padding: 4vmin 0;

  #media-breakpoint-up(md, {
    padding: 5vmin 0;
  });

  #media-breakpoint-up(lg, {
    padding: 6vmin 0;
  });
}
</style>
